import { render, staticRenderFns } from "./MenuItemDetails.vue?vue&type=template&id=2cf3332f&scoped=true&"
import script from "./MenuItemDetails.vue?vue&type=script&lang=js&"
export * from "./MenuItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemDetails.vue?vue&type=style&index=0&id=2cf3332f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3332f",
  null
  
)

export default component.exports